import { TripsOverviewImportant } from "components/flexComponents/TripsOverviewImportant/TripsOverviewImportant";
import { TripsBexApiWrapper } from "components/shared/BexApiWrapper/TripsBexApiWrapper";

export const TripsOverviewImportantWrapper = TripsBexApiWrapper(TripsOverviewImportant);
export default TripsOverviewImportantWrapper;
